import API from '../utils/api'

const contactsApiBaseUrl = '/api/contacts';
const contentUrl = contactsApiBaseUrl + '/getcontacts/';


export function findContacts(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}